import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Storage } from '@ionic/storage-angular';

import { ModalController, AlertController } from '@ionic/angular';

import { EstatusService } from 'src/app/services/estatus.service';

@Component({
  selector: 'app-popover-description',
  templateUrl: './popover-description.component.html',
  styleUrls: ['./popover-description.component.scss'],
})
export class PopoverDescriptionComponent implements OnInit {

  @Input() idStatus;
  descriptionForm: FormGroup;

  idAdmin: any;
  classUser: any;
  canal: any;
  canales: any;
  canalInicial: any;

  listaEstatus: any;

  constructor(
    private alertController: AlertController,
    private storage: Storage,
    private modal: ModalController,
    private formBuilder: FormBuilder,
    private estatus: EstatusService,
  ) {
    this.canales = [];
    this.listaEstatus = [];
  }

  ngOnInit() {
    this.descriptionForm = this.formBuilder.group({
      description: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(250)]]
    });

    this.getCanal();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec === this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
    this.getAllEstatus();
  }

  getAllEstatus() {
    this.estatus.getAllEstatus(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, this.classUser.canale.url_back
    ).subscribe((res: any) => {
      const { status, listaEstatus } = res;
      if (status === 'success') {
        this.listaEstatus = listaEstatus;

        this.listaEstatus.forEach(item => {
          if (item.id === this.idStatus && item.analisis_ia !== null) {
            this.descriptionForm.get('description').setValue(item.analisis_ia);
          }
        });
      }
    });
  }

  descriptionSubmit() {
    const data = {
      analisis_ia: this.descriptionForm.value.description
    };

    this.estatus.editarEstatus(data, this.idStatus, this.classUser.id, this.classUser.rol,
      this.classUser.token, this.classUser.canale.url_back).subscribe((res: any) => {
        const { status } = res;
        if (status === 'success') {
          this.presentAlert('Descripción actualiza', 'Su descripción se actualizo correctamente', '');
          this.getAllEstatus();
          this.cancelar();
        } else {
          this.presentAlert('Hubo un problema', 'Por favor intente de nuevo', '');
          this.cancelar();
        }
      });
  }

  cancelar() {
    this.modal.dismiss();
    this.descriptionForm.reset();
  }

  async presentAlert(header, subheader, mensaje) {
    const alert = await this.alertController.create({
      cssClass: 'animate__animated animate__fadeIn',
      header,
      subHeader: subheader,
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
  }

}
